import { FormField } from 'src/common/FormField';
import { FormFieldController } from 'src/common/FormField/FormFieldController';

interface TimeFieldProps {
  contextName: string;
  rules: any;
  label: string;
  inputProps: any;
}

export default function TimeField({
  contextName,
  rules,
  label,
  inputProps,
}: TimeFieldProps) {
  return (
    <FormFieldController name={contextName} rules={rules}>
      {({ field, fieldState }) => {
        return (
          <FormField
            label={label}
            error={fieldState.error?.message?.toString()}
            inputProps={{ ...inputProps, value: field.value }}
            {...field}
            type="time"
          />
        );
      }}
    </FormFieldController>
  );
}
